import { useEffect, useState, type RefObject } from 'react'

const VIEWPORT_EDGE_PADDING = 10

export function useDismissOnOutsideOrEscape(
  menuRef: RefObject<HTMLElement | null>,
  onClose: () => void
): void {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent): void => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) onClose()
    }
    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [menuRef, onClose])
}

export function useViewportClampedPosition(
  menuRef: RefObject<HTMLElement | null>,
  x: number,
  y: number
): { x: number; y: number } {
  const [position, setPosition] = useState({ x, y })
  useEffect(() => {
    if (!menuRef.current) return
    const rect = menuRef.current.getBoundingClientRect()
    const maxX = window.innerWidth - rect.width - VIEWPORT_EDGE_PADDING
    const maxY = window.innerHeight - rect.height - VIEWPORT_EDGE_PADDING
    const newX = x + rect.width > window.innerWidth - VIEWPORT_EDGE_PADDING ? maxX : x
    const newY = y + rect.height > window.innerHeight - VIEWPORT_EDGE_PADDING ? maxY : y
    if (newX !== x || newY !== y) setPosition({ x: newX, y: newY })
  }, [menuRef, x, y])
  return position
}
